/**
 * Owner: Masa Bayu
 * File: AuthorFollowButton.tsx
 * Date:Time: 2026-10-19 12:40
 * Description: §411–§412 — butang Follow dikongsi: varian 'outline' (senarai
 *   trending/kad featured) dan 'solid' (hero profil); keadaan sebenar daripada
 *   stor localStorage qxread:author-follows:v1.
 */

import type { ReactElement } from 'react';
import './author-bits.css';

export interface AuthorFollowButtonProps {
  readonly following: boolean;
  readonly onToggle: () => void;
  readonly followLabel: string;
  readonly followingLabel: string;
  readonly variant?: 'outline' | 'solid';
  readonly ariaName?: string;
}

export function AuthorFollowButton({
  following,
  onToggle,
  followLabel,
  followingLabel,
  variant = 'outline',
  ariaName,
}: AuthorFollowButtonProps): ReactElement {
  return (
    <button
      type="button"
      className={`qxflw qxflw--${variant}`}
      aria-pressed={following}
      {...(ariaName !== undefined
        ? { 'aria-label': `${following ? followingLabel : followLabel} — ${ariaName}` }
        : {})}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      {following ? followingLabel : followLabel}
    </button>
  );
}
